var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.dialogVisible,
            "append-to-body": true,
            width: "1200px",
            "close-on-click-modal": false
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogVisible = $event
            },
            close: _vm.closePopup
          }
        },
        [
          _c(
            "el-tabs",
            {
              staticStyle: { "margin-bottom": "10px" },
              on: { "tab-click": _vm.handleClick },
              model: {
                value: _vm.activeName,
                callback: function($$v) {
                  _vm.activeName = $$v
                },
                expression: "activeName"
              }
            },
            [
              _c(
                "el-tab-pane",
                { attrs: { label: "商品统计", name: "goods" } },
                [
                  _c("div", { staticClass: "table-container" }, [
                    _c(
                      "div",
                      { staticClass: "btn-wrap" },
                      [
                        _c("el-input", {
                          staticStyle: {
                            width: "200px",
                            "margin-right": "10px"
                          },
                          attrs: {
                            size: "mini",
                            "suffix-icon": "el-icon-search",
                            placeholder: "商品名称",
                            clearable: ""
                          },
                          on: {
                            clear: _vm.getTableData1,
                            blur: _vm.getTableData1
                          },
                          model: {
                            value: _vm.table1Params.name,
                            callback: function($$v) {
                              _vm.$set(_vm.table1Params, "name", $$v)
                            },
                            expression: "table1Params.name"
                          }
                        }),
                        _c("el-date-picker", {
                          staticStyle: { width: "240px" },
                          attrs: {
                            size: "mini",
                            type: "daterange",
                            "value-format": "yyyy-MM-dd",
                            "range-separator": "-",
                            "start-placeholder": "发送开始时间",
                            "end-placeholder": "发送结束时间",
                            "picker-options": _vm.pickerOptions,
                            clearable: false
                          },
                          on: { change: _vm.selectTime1 },
                          model: {
                            value: _vm.searchSelectTime1,
                            callback: function($$v) {
                              _vm.searchSelectTime1 = $$v
                            },
                            expression: "searchSelectTime1"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "table-data" },
                      [
                        _c(
                          "el-table",
                          {
                            directives: [
                              {
                                name: "loading",
                                rawName: "v-loading",
                                value: _vm.loading1,
                                expression: "loading1"
                              }
                            ],
                            ref: "singleTable",
                            staticStyle: {
                              width: "100%",
                              height: "100%",
                              "font-size": "13px"
                            },
                            attrs: {
                              size: "medium",
                              "header-cell-style": {
                                background: "#eef1f6",
                                color: "#606266"
                              },
                              "highlight-current-row": true,
                              data: _vm.tableData1,
                              height: "308px"
                            },
                            on: { "sort-change": _vm.customerSortChange1 }
                          },
                          [
                            _c("el-table-column", {
                              attrs: {
                                label: "序号",
                                width: "65",
                                align: "center"
                              },
                              scopedSlots: _vm._u([
                                {
                                  key: "default",
                                  fn: function(scope) {
                                    return [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.table1Params.size *
                                              (_vm.table1Params.page - 1) +
                                              (scope.$index + 1)
                                          ) +
                                          " "
                                      )
                                    ]
                                  }
                                }
                              ])
                            }),
                            _c("el-table-column", {
                              attrs: {
                                "show-overflow-tooltip": "",
                                prop: "name",
                                label: "商品名称",
                                width: "118",
                                align: "left"
                              }
                            }),
                            _c("el-table-column", {
                              attrs: {
                                prop: "shareNumber",
                                label: "发送次数",
                                sortable: "custom",
                                "min-width": "102",
                                align: "center"
                              }
                            }),
                            _c("el-table-column", {
                              attrs: {
                                prop: "shareOpenNumber",
                                label: "点击次数",
                                sortable: "custom",
                                "min-width": "102",
                                align: "center"
                              }
                            }),
                            _c("el-table-column", {
                              attrs: {
                                prop: "openRate",
                                label: "打开率",
                                sortable: "custom",
                                "min-width": "144",
                                align: "center"
                              }
                            }),
                            _c("el-table-column", {
                              attrs: {
                                prop: "shelvesOrderNumber",
                                label: "商品成交量",
                                "min-width": "102",
                                align: "center"
                              }
                            }),
                            _c("el-table-column", {
                              attrs: {
                                prop: "orderRate",
                                label: "商品成交率",
                                "min-width": "102",
                                align: "center"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "staff-pagination" },
                      [
                        _c("el-pagination", {
                          attrs: {
                            "current-page": _vm.table1Params.page,
                            "page-size": _vm.table1Params.size,
                            layout: "total, sizes, prev, pager, next, jumper",
                            total: _vm.total1,
                            "page-sizes": [20, 50, 100, 200, 500]
                          },
                          on: {
                            "current-change": _vm.changePage,
                            "size-change": _vm.changeSize
                          }
                        })
                      ],
                      1
                    )
                  ])
                ]
              ),
              _c("el-tab-pane", { attrs: { label: "活动统计", name: "act" } }, [
                _c("div", { staticClass: "table-container" }, [
                  _c(
                    "div",
                    { staticClass: "btn-wrap" },
                    [
                      _c("el-input", {
                        staticStyle: { width: "200px", "margin-right": "10px" },
                        attrs: {
                          size: "mini",
                          "suffix-icon": "el-icon-search",
                          placeholder: "活动名称",
                          clearable: ""
                        },
                        on: {
                          clear: _vm.getTableData2,
                          blur: _vm.getTableData2
                        },
                        model: {
                          value: _vm.table2Params.name,
                          callback: function($$v) {
                            _vm.$set(_vm.table2Params, "name", $$v)
                          },
                          expression: "table2Params.name"
                        }
                      }),
                      _c(
                        "span",
                        {
                          staticStyle: {
                            border: "1px solid #C0C4CC",
                            height: "28px",
                            "line-height": "28px",
                            "border-radius": "4px",
                            padding: "0 15px",
                            "box-sizing": "border-box"
                          }
                        },
                        [_vm._v("发送时间")]
                      ),
                      _c("el-date-picker", {
                        staticStyle: { width: "240px", "margin-right": "10px" },
                        attrs: {
                          size: "mini",
                          type: "daterange",
                          "value-format": "yyyy-MM-dd",
                          "range-separator": "-",
                          "start-placeholder": "发送开始时间",
                          "end-placeholder": "发送结束时间",
                          "picker-options": _vm.pickerOptions,
                          clearable: false
                        },
                        on: { change: _vm.selectTime2 },
                        model: {
                          value: _vm.searchSelectTime2,
                          callback: function($$v) {
                            _vm.searchSelectTime2 = $$v
                          },
                          expression: "searchSelectTime2"
                        }
                      }),
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "200px" },
                          attrs: {
                            size: "mini",
                            placeholder: "请选择活动类型"
                          },
                          on: { change: _vm.getTableData2 },
                          model: {
                            value: _vm.table2Params.type,
                            callback: function($$v) {
                              _vm.$set(_vm.table2Params, "type", $$v)
                            },
                            expression: "table2Params.type"
                          }
                        },
                        _vm._l(_vm.optionsAct, function(item) {
                          return _c("el-option", {
                            key: item.value,
                            attrs: { label: item.label, value: item.value }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "table-data" },
                    [
                      _c(
                        "el-table",
                        {
                          directives: [
                            {
                              name: "loading",
                              rawName: "v-loading",
                              value: _vm.loading2,
                              expression: "loading2"
                            }
                          ],
                          ref: "singleTable",
                          staticStyle: {
                            width: "100%",
                            height: "100%",
                            "font-size": "13px"
                          },
                          attrs: {
                            size: "medium",
                            "header-cell-style": {
                              background: "#eef1f6",
                              color: "#606266"
                            },
                            "highlight-current-row": true,
                            data: _vm.tableData2,
                            height: "308px"
                          },
                          on: { "sort-change": _vm.customerSortChange2 }
                        },
                        [
                          _c("el-table-column", {
                            attrs: {
                              label: "序号",
                              width: "65",
                              align: "center"
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.table2Params.size *
                                            (_vm.table2Params.page - 1) +
                                            (scope.$index + 1)
                                        ) +
                                        " "
                                    )
                                  ]
                                }
                              }
                            ])
                          }),
                          _c("el-table-column", {
                            attrs: {
                              "show-overflow-tooltip": "",
                              prop: "name",
                              label: "活动名称",
                              width: "118",
                              align: "left"
                            }
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "shareNumber",
                              label: "发送次数",
                              sortable: "custom",
                              "min-width": "102",
                              align: "center"
                            }
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "shareOpenNumber",
                              label: "点击次数",
                              sortable: "custom",
                              "min-width": "102",
                              align: "center"
                            }
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "rate",
                              label: "打开率",
                              sortable: "custom",
                              "min-width": "144",
                              align: "center"
                            }
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "registerNumber",
                              label: "活动注册人数",
                              sortable: "custom",
                              "min-width": "102",
                              align: "center"
                            }
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "orderNumber",
                              label: "活动下单人数",
                              "min-width": "102",
                              align: "center"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "staff-pagination" },
                    [
                      _c("el-pagination", {
                        attrs: {
                          "current-page": _vm.table2Params.page,
                          "page-size": _vm.table2Params.size,
                          layout: "total, sizes, prev, pager, next, jumper",
                          total: _vm.total2,
                          "page-sizes": [20, 50, 100, 200, 500]
                        },
                        on: {
                          "current-change": _vm.changePage2,
                          "size-change": _vm.changeSize2,
                          "update:currentPage": function($event) {
                            return _vm.$set(_vm.table2Params, "page", $event)
                          },
                          "update:current-page": function($event) {
                            return _vm.$set(_vm.table2Params, "page", $event)
                          },
                          "update:pageSize": function($event) {
                            return _vm.$set(_vm.table2Params, "size", $event)
                          },
                          "update:page-size": function($event) {
                            return _vm.$set(_vm.table2Params, "size", $event)
                          }
                        }
                      })
                    ],
                    1
                  )
                ])
              ])
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }